import * as React from "react";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import { DropdownButton, Button } from "components/bootstrap";
import MenuItem from "components/bootstrap/menuitem/MenuItem";
import { defaultCompare } from "logic/DefaultCompare";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { IconButton } from "components/common";
import usePermissions from "hooks/usePermissions";
const SliceHeader = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacings.xs};
    justify-content: space-between;
    margin-bottom: ${theme.spacings.sm};
  `
);
const HeaderActions = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacings.sm};
  `
);
const SliceHeaderControls = ({
  appSection,
  activeColumnTitle,
  activeSlice,
  sliceCol,
  columnSchemas,
  onChangeSlicing,
  isSlicingReadOnly
}) => {
  const { t } = useTranslation("common");
  const { isPermitted } = usePermissions();
  const sliceableColumns = columnSchemas.filter((schema) => schema.sliceable && isPermitted(schema.permissions)).sort(({ title: title1 }, { title: title2 }) => defaultCompare(title1, title2));
  const sendTelemetry = useSendTelemetry(appSection);
  const onSliceColumn = (columnId) => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.ENTITY_DATA_TABLE.SLICE_COLUMN_SELECTED_SECTION, {
      app_action_value: "slice-column-select",
      event_details: { attribute_id: columnId }
    });
    onChangeSlicing(columnId);
  };
  const onRemoveSlicing = () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.ENTITY_DATA_TABLE.SLICE_REMOVED, {
      app_action_value: "slice-remove",
      event_details: { attribute_id: sliceCol }
    });
    onChangeSlicing(null, null);
  };
  return /* @__PURE__ */ React.createElement(SliceHeader, null, /* @__PURE__ */ React.createElement(DropdownButton, { bsSize: "small", title: activeColumnTitle != null ? activeColumnTitle : t("slicing.slice_by"), disabled: isSlicingReadOnly }, /* @__PURE__ */ React.createElement(MenuItem, { header: true }, t("slicing.slice_by")), sliceableColumns.map((schema) => /* @__PURE__ */ React.createElement(MenuItem, { key: schema.id, onClick: () => onSliceColumn(schema.id) }, schema.title))), /* @__PURE__ */ React.createElement(HeaderActions, null, activeSlice && /* @__PURE__ */ React.createElement(Button, { bsStyle: "link", bsSize: "sm", onClick: () => onChangeSlicing(sliceCol, void 0) }, t("slicing.unselect_slice")), /* @__PURE__ */ React.createElement(
    IconButton,
    {
      disabled: isSlicingReadOnly,
      name: "close",
      title: t("slicing.no_slicing"),
      onClick: onRemoveSlicing
    }
  )));
};
export default SliceHeaderControls;
